module.exports = __webpack_public_path__ + "img/level-1.999dd93a.svg";